import * as Yup from 'yup';

export default Yup.object().shape({
  newPassword: Yup.string()
    .matches(/(?=.*[A-Z])/, 'validationErrors.invalidPasswordMissingUppercase')
    .matches(/(?=.*[a-z])/, 'validationErrors.invalidPasswordMissingLowercase')
    .matches(/(?=.*[0-9])/, 'validationErrors.invalidPasswordMissingDigit')
    .min(8, 'validationErrors.minLength')
    .required('validationErrors.isRequired'),
  repeatPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), ''], 'validationErrors.passwordsDoNotMatch')
    .required('validationErrors.isRequired'),
});
